import { useEffect } from "react";

/**
 * CapgoBootstrap — calls `CapacitorUpdater.notifyAppReady()` once on
 * mount so Capgo OTA knows the freshly-downloaded JS bundle started
 * cleanly. Without this call within the `appReadyTimeout` window
 * (configured to 10s in capacitor.config.ts), Capgo treats the new
 * bundle as broken and reverts to the previous valid one on next launch.
 *
 * Dynamic import + try/catch so:
 *   • Web preview (no @capgo native plugin) silently no-ops.
 *   • TestFlight / App Store builds where the native binding exists
 *     fire the notify call within a frame of first render.
 *
 * Renders nothing. Lives in AppShell so it mounts exactly once for the
 * lifetime of the app session.
 */
const CapgoBootstrap = () => {
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const mod = await import("@capgo/capacitor-updater");
        if (cancelled) return;
        const { CapacitorUpdater } = mod;
        if (!CapacitorUpdater?.notifyAppReady) return;
        await CapacitorUpdater.notifyAppReady();
        // Surface for in-app diagnostics; harmless on web.
        // eslint-disable-next-line no-console
        console.log("[Capgo] notifyAppReady() ok");
      } catch (err) {
        // eslint-disable-next-line no-console
        console.warn("[Capgo] notifyAppReady() skipped:", err?.message || err);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return null;
};

export default CapgoBootstrap;
